

import { Component, Mixins, Prop } from 'vue-property-decorator';
import { PopupModule } from '~common-store/modules/popup';
import PopupHeader from '~common-components/Popup/PopupHeader.vue';
import PopupBody from '~common-components/Popup/PopupBody.vue';
import PopupFooter from '~common-components/Popup/PopupFooter.vue';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component({
    components: {
        PopupHeader,
        PopupBody,
        PopupFooter,
    },
})
export default class Popup extends Mixins(DarkThemeInfoMixin) {
    @Prop({ default: '' }) readonly headerTitle: string | undefined;
    @Prop({ default: '' }) readonly headerSubtitle: string | undefined;
    @Prop({ default: false }) readonly isFullScreen: boolean | undefined;
    @Prop({ default: 0.75 }) readonly maxWidth: number | undefined;

    get isPopupRequested() {
        return PopupModule.isPopupRequested;
    }

    get dialogMaxWidth() {
        return this.$vuetify.breakpoint.width * this.$props.maxWidth + 'px';
    }

    setPopupInactive() {
        PopupModule.setPopupInactive();
    }
}
